export const FETCHED_ALL = 'RULES_FETCHED_ALL';
export const fetchedAll = (rules: any) => ({
    type: FETCHED_ALL,
    payload: rules,
});
